interface EmbedData {
  code?: string
}

const hydratedHeaderVideos = new WeakSet<HTMLElement>()

export function hydrateHeaderVideoStripes(
  container: Document | Element = document
): void {
  const headerVideos = container.querySelectorAll<HTMLElement>(
    '.vssl-stripe--header-video'
  )

  headerVideos.forEach((stripeEl) => {
    if (hydratedHeaderVideos.has(stripeEl)) return
    hydratedHeaderVideos.add(stripeEl)

    const videoUI = stripeEl.querySelector<HTMLElement>(
      '.vssl-stripe--header-video--ui'
    )
    const bgVideo = videoUI?.querySelector<HTMLVideoElement>('video')
    const playButton = stripeEl.querySelector<HTMLAnchorElement>(
      'a.vssl-stripe--header-video--playbtn-wrap'
    )
    const embedWrap = stripeEl.querySelector<HTMLElement>(
      '.vssl-stripe--header-video--embed'
    )

    if (!playButton || !embedWrap) return

    let embed: HTMLElement | null = null
    let isEmbedLoaded = false

    function toggle(): void {
      if (isEmbedLoaded) {
        close()
      } else {
        open()
      }
      isEmbedLoaded = !isEmbedLoaded
    }

    function close(): void {
      stripeEl.removeAttribute('data-is-video-showing')
      if (embed?.parentElement) {
        embed.parentElement.removeChild(embed)
      }
      bgVideo?.pause()
    }

    function open(): void {
      stripeEl.setAttribute('data-is-video-showing', 'true')
      if (embed) {
        embedWrap?.appendChild(embed)
      }
      bgVideo?.play()
    }

    // Parse embed data from data-video-embed attribute
    const embedDataJSON = embedWrap.getAttribute('data-video-embed')
    const embedData: EmbedData | null = JSON.parse(embedDataJSON || 'null')

    if (embedData?.code) {
      const tempDiv = document.createElement('div')
      tempDiv.innerHTML = embedData.code
      embed = tempDiv.firstChild as HTMLElement

      // Auto-add autoplay parameter to embed src if not present
      if (embed) {
        const embedSrc = embed.getAttribute('src')
        if (embedSrc) {
          const hasAutoplay = /^(.*)autoplay=1(.*)$/.test(embedSrc)
          const hasParameters = /^(.*)(\?)(.+)$/.test(embedSrc)
          if (!hasAutoplay) {
            const prefix = hasParameters ? '&' : '?'
            embed.setAttribute('src', embedSrc + prefix + 'autoplay=1')
          }
        }
      }
    }

    playButton.addEventListener('click', function (e) {
      e.preventDefault()
      this.blur()
      toggle()
    })
  })
}
